import { Box, CircularProgress, Typography } from "@mui/material";
import React, { forwardRef } from "react";
import { Constants } from "services/keyConstants";
import SkeletonTable from "components/SkeletonTable";
import CustomeTable from "./Table/CustomeTable";
import CustomeForm from "./Form/CustomeForm";
import { getItem } from "services/utils";
import CustomeNestedTable from "./NestedTable/CustomeNestedTable";
import MainHeader from "./CustomHeader/MainHeader";
import StructureTable from "./Structure/StructureTable";
import StructureForm from "./Structure/StructureForm";
import StructureNested from "./Structure/StructureNested";
import HTML_Table from "./HTML_Tables/Table/HTML_Table";
import HTML_NestedTable from "./HTML_Tables/NestedTable/HTML_NestedTable";
import HTML_Form from "./HTML_Tables/Form/HTML_Form";

const CustomizeDynamicTable = (props, ref) => {
  const { config, columns = [], isLoading = true, headerData } = props;
  const userData = getItem(Constants.KEY_USER_DATA);
  const selectedRole = getItem(Constants.KEY_SELECTED_ROLE);

  if (isLoading === true) {
    return (
      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          padding: "0px 30px",
        }}
      >
        <SkeletonTable />
      </Box>
    );
  }

  // if ((!isLoading) && (columns?.length === 0)) {
  //   return (
  //     <Box
  //       sx={{
  //         width: "100%",
  //         overflowX: "auto",
  //         padding: "0px 30px",
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           width: "100%",
  //           height: "60px",
  //           bgcolor: "#FF000030",
  //           border: "1px solid red",
  //           borderRadius: "10px",
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //         }}
  //       >
  //         <Typography color={"red"} fontWeight={"600"} variant="h4">
  //           Columns are undefined
  //         </Typography>
  //       </Box>
  //     </Box>
  //   );
  // }

  if (!isLoading && columns?.length === 0) {
    return (
      <div
        style={{
          width: "100%",
          minHeight: "200px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <CircularProgress />
        <span
          style={{
            fontSize: "16px",
            fontWeight: 500,
            color: "#555",
          }}
        >
          Loading... Please wait
        </span>
      </div>
    );
  }

  if (!!config?.isHTML) {
    if (config?.type === "table") {
      return <HTML_Table {...props} />
    } else if (config?.type === "nested-table") {
      return <HTML_NestedTable {...props} />
    } else if (config?.type === "form-table") {
      return <HTML_Form {...props} />
    }
  }

  if (!!config?.isStructure && config?.type !== "form") {
    if (config?.type === "table") {
      return <StructureTable {...props} />;
    } else if (config?.type === "nested-table") {
      return <StructureNested {...props} />;
    }
  } else if (config?.type === "table") {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        {headerData ? <MainHeader rows={headerData} /> : null}
        <CustomeTable
          data={props}
          userData={userData}
          selectedRole={selectedRole}
        />
      </Box>
    );
  } else if (config?.type === "form") {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        {headerData ? <MainHeader rows={headerData} /> : null}
        <CustomeForm data={props} userData={userData} />
      </Box>
    );
  } else if (config?.type === "nested-table") {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        {headerData ? <MainHeader rows={headerData} /> : null}
        <CustomeNestedTable data={props} userData={userData} />
      </Box>
    );
  }
  // else if (defaultConfig?.type === "form") {
  //   return (
  //     <>
  //       <TableContainer component={Paper}>
  //         <Table>
  //           <TableBody>
  //             <FormRows
  //               columns={columns}
  //               rows={rows}
  //               config={{
  //                 ...defaultConfig,
  //                 rows,
  //                 columns,
  //                 renderColumns: renderRef?.current?.columnsRender
  //               }}
  //               errorRef={rowsErrorRef}
  //             />
  //           </TableBody>
  //         </Table>
  //       </TableContainer>
  //     </>
  //   )
  // }
};

const WrappedCustomizeDynamicTable = forwardRef(CustomizeDynamicTable);
WrappedCustomizeDynamicTable.__IS_DYNAMIC_TABLE__ = true;

export default WrappedCustomizeDynamicTable;
